import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { BetaChartCard } from 'src/pages/reports/components/beta-charts';
import { BetaChartAreaSkeleton } from 'src/pages/reports/components/beta-charts/beta-chart-skeletons';
import { BetaChartTooltip } from 'src/pages/reports/components/beta-charts/beta-chart-tooltip';
import { formatCompactNumber } from './overview-beta-format';

export interface CumulativeSpendPoint {
  date: string;
  dateLabel: string;
  cumulative: number;
  daily: number;
}

interface OverviewBetaCumulativeSpendProps {
  data: CumulativeSpendPoint[];
  isLoading?: boolean;
}

export function OverviewBetaCumulativeSpend({
  data,
  isLoading = false,
}: OverviewBetaCumulativeSpendProps) {
  return (
    <BetaChartCard
      title="Cumulative Spend"
      subtitle="Running total across enabled platforms"
      className="mb-0"
    >
      {isLoading ? (
        <BetaChartAreaSkeleton className="h-[240px]" />
      ) : data.length === 0 ? (
        <div className="flex h-[240px] items-center justify-center text-sm text-[#8A8EA0]">
          No spend trend for the selected period.
        </div>
      ) : (
        <div className="h-[240px] w-full">
          <ResponsiveContainer
            width="100%"
            height="100%"
          >
            <AreaChart
              data={data}
              margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient
                  id="cumSpendFill"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="0%"
                    stopColor="#EF4444"
                    stopOpacity={0.28}
                  />
                  <stop
                    offset="100%"
                    stopColor="#EF4444"
                    stopOpacity={0.02}
                  />
                </linearGradient>
              </defs>
              <CartesianGrid
                stroke="#EDEEF2"
                vertical={false}
              />
              <XAxis
                dataKey="dateLabel"
                tick={{ fill: '#8A8EA0', fontSize: 11 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                tick={{ fill: '#8A8EA0', fontSize: 11 }}
                tickLine={false}
                axisLine={false}
                width={52}
                tickFormatter={(value) => formatCompactNumber(Number(value), { currency: true })}
              />
              <Tooltip
                content={(
                  <BetaChartTooltip
                    valueFormatter={(value) => formatCompactNumber(value, { currency: true })}
                  />
                )}
                cursor={{ stroke: '#D9DBE3', strokeWidth: 1 }}
              />
              <Area
                type="monotone"
                dataKey="cumulative"
                name="Cumulative spend"
                stroke="#EF4444"
                fill="url(#cumSpendFill)"
                strokeWidth={2}
                dot={false}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </BetaChartCard>
  );
}
